/**
 * Status de um lançamento de faturamento:
 * - closed    → recebido, sem procedimentos desligados (em aberto)
 * - partial   → recebido, com 1+ procedimentos desligados
 * - quoted  → não recebido (orçamento)
 */
export type RevenueStatus = "closed" | "partial" | "quoted";

export const REVENUE_STATUS_LABELS: Record<RevenueStatus, string> = {
  closed: "Fechado",
  partial: "Fechado parcialmente",
  quoted: "Orçado",
};

/** Rótulos curtos usados em listas compactas (ex.: Lançamentos da Semana). */
export const REVENUE_STATUS_SHORT_LABELS: Record<RevenueStatus, string> = {
  closed: "Fechado",
  partial: "Parcial",
  quoted: "Orçado",
};

/** Classes de cor (badge) por status */
export const REVENUE_STATUS_BADGE: Record<RevenueStatus, string> = {
  closed: "bg-success-soft text-success",
  partial: "bg-warning/10 text-warning",
  quoted: "bg-muted text-muted-foreground",
};

/** Classes de cor (texto) por status */
export const REVENUE_STATUS_TEXT: Record<RevenueStatus, string> = {
  closed: "text-success",
  partial: "text-warning",
  quoted: "text-muted-foreground",
};

interface RevenueStatusItem {
  active?: boolean | null;
}

interface RevenueStatusEntry {
  received?: boolean | null;
  revenue_entry_items?: RevenueStatusItem[] | null;
}

export function getRevenueStatus(entry: object | null | undefined): RevenueStatus {
  if (!entry) return "quoted";
  const e = entry as RevenueStatusEntry;
  if (e.received !== true) return "quoted";
  const items = e.revenue_entry_items;
  if (Array.isArray(items) && items.some((i) => i?.active === false)) return "partial";
  return "closed";
}

const ORDER: Record<RevenueStatus, number> = { closed: 0, partial: 1, quoted: 2 };

/** Estado mais "aberto" entre vários lançamentos */
export function worstRevenueStatus(statuses: RevenueStatus[]): RevenueStatus | undefined {
  if (statuses.length === 0) return undefined;
  return statuses.reduce((worst, s) => (ORDER[s] > ORDER[worst] ? s : worst), statuses[0]);
}
